import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { Tenant } from 'src/app/shared/models/tenant';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { AppConfig } from 'src/app/shared/models/config/appConfig';
import { TenantModuleType } from 'src/app/shared/models/tenantModuleType';

@Injectable({ providedIn: 'root' })
export class PortalInitializationService {
  public static readonly EnvironmentSettingsLocation: string = '/assets/config/environment.json';

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private router: Router
  ) {}

  get baseApiUrl(): string {
    return this.appConfigService.baseApiUrl;
  }

  load(): Promise<AppConfigService> {
    return lastValueFrom(
      this.http.get(
        PortalInitializationService.EnvironmentSettingsLocation + '?t=' + new Date().getTime()
      )
    )
      .then((res: any) => {
        res.isPortal = true;
        res.baseRoute = '/portal';
        this.appConfigService.config = AppConfig.parse(res);
      })
      .then(() => {
        return lastValueFrom(this.http.get(this.baseApiUrl.concat('tenants/current')));
      })
      .then((res) => {
        this.appConfigService.tenant = Tenant.parse(res);
        if (this.appConfigService.tenant) {
          const hasPortalModule = this.appConfigService.tenant.modules?.some(
            (m) => m.moduleType === TenantModuleType.Portal
          );
          if (!hasPortalModule) {
            this.router.navigate(['/not-found']);
          }

          this.appConfigService.tenant.branding?.applyToDocument();
        }

        this.appConfigService.initialized = true;
        this.appConfigService.loadError = false;
        return this.appConfigService;
      })
      .catch((error: any) => {
        this.appConfigService.initialized = false;
        this.appConfigService.loadError = true;
        this.router.navigate(['/maintenance-mode'], { skipLocationChange: true });
        return this.appConfigService;
      });
  }
}
